






















































































































import Vue from 'vue';
import { mapState } from 'vuex';
import _ from 'lodash';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import TrashCanOutlineIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import Content from '@/dex-shared/components/content/Content.vue';
import InteractiveData from '@/components/question/interactive_data/InteractiveData.vue';
import SolutionShow from '@/views/solution/SolutionShow.vue';
import QuestionReports from '@/components/question/QuestionReports.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import KnowledgeShow from '@/components/knowledge/KnowledgeShow.vue';
import TreeKnowledgeShow from '@/components/knowledge/TreeKnowledgeShow.vue';

export default Vue.extend({
  components: {
    Content,
    InteractiveData,
    SolutionShow,
    QuestionReports,
    pxCard,
    pxButton,
    Loading,
    SquareEditOutlineIcon,
    TrashCanOutlineIcon,
    KnowledgeShow,
    TreeKnowledgeShow,
  },

  data() {
    return {
      loaded: true,
    };
  },

  computed: {
    ...mapState({
      question: (state: any) => state.questions.question,
    }),
    orderedSolutions() {
      if (
        !this.question ||
        !this.question.solutions ||
        !this.question.solutions.length
      )
        return [];

      const solutions = this.question.solutions.map(s => ({
        ...s,
        balance: s.cachedVotesUp - s.cachedVotesDown,
        validation: s.validation ? 1 : 0,
        fromAdmin: s.user.role === 'admin' ? 1 : 0,
        validatedByAdmin:
          s.validatedBy == null ? 0 : s.validationJudgment ? 1 : 0,
      }));

      return _.orderBy(
        solutions,
        ['fromAdmin', 'validatedByAdmin', 'balance', 'updatedAt'],
        ['desc', 'desc', 'desc', 'desc'],
      );
    },
  },

  async created() {
    let questionId = parseInt(this.$route.params.questionId);
    this.loaded = false;
    await this.$store.dispatch('PULL_QUESTION', questionId);
    if (this.question.id === null) this.$router.push('/404');
    this.loaded = true;
  },

  methods: {
    async removeSolution(solutionId: number, index: number) {
      if (confirm('Tem certeza que deseja deletar essa solução?')) {
        let response = await this.$store.dispatch(
          'REMOVE_SOLUTION',
          solutionId,
        );

        if (response === true) {
          this.$store.commit('REMOVE_SOLUTION_FROM_QUESTION', index);
          //TODO change this reload
          this.loaded = false;
          await this.$store.dispatch('PULL_QUESTION', this.question.id);
          this.loaded = true;
        } else {
          //TODO analyze the error
          alert('Essa solução não pode ser removida');
        }
      }
    },
    removeQuestion: async function() {
      if (
        confirm(
          'Tem certeza que deseja deletar essa questão? Ela não poderá ser recuperada!',
        )
      ) {
        const response = await this.$store.dispatch(
          'REMOVE_QUESTION',
          this.question.id,
        );
        if (response === true) {
          alert('Questão deletada!');
          this.$router.push('/questoes');
        } else {
          //TODO analyze the error
          alert(
            'Essa questão não pode ser deletada pois está em alguma prova, lista, ou tem respostas associadas a ela',
          );
        }
      }
    },
    isBestVoted(solutionIndex) {
      const solution = this.orderedSolutions[solutionIndex];
      const balance = solution.cachedVotesUp - solution.cachedVotesDown;
      const hasTiedBalances =
        this.orderedSolutions.filter(
          s => s.cachedVotesUp - s.cachedVotesDown === balance,
        ).length > 1;

      return balance > 0 && solutionIndex === 0 && !hasTiedBalances;
    },
  },
});
